import styles from "../Menu.module.css";

export const SideBarHorizontalDivider = () => (
  <div className={styles.sideBarHorizontalDivider} />
);
export default SideBarHorizontalDivider;
